import styled from 'styled-components';
import { images } from 'config';
import { shades } from 'utils';

const { teals } = shades;

const DownloadLink = styled.a`
  color: ${teals.tilicho};
  cursor: pointer;  
  line-height: 1.4;
  &:after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: 22px;
    height: 18px;
    background: url('${images.icons.download}') no-repeat;
    margin: 0 10px 0 12px;
  }

  &:hover{
  }

`;

export default DownloadLink;



// WEBPACK FOOTER //
// ./src/components/styled/ui/downloadLink/downloadLink.js